/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import GlobalScope from '../globalScope/GlobalScope';
import IPeerConnectionFactory from './IPeerConnectionFactory';
import IPeerConnection from './IPeerConnection';
import VanillaPeerConnection from './VanillaPeerConnection';

export default class VanillaPeerConnectionFactory implements IPeerConnectionFactory {
  async createPeerConnection(configuration?: RTCConfiguration): Promise<IPeerConnection> {
    return new Promise<IPeerConnection>(resolvePeerConnectionPromise => {
      const globalScopeSubscription = GlobalScope.subscribe(globalScope => {
        if (!globalScope) {
          return;
        }

        resolvePeerConnectionPromise(new VanillaPeerConnection(configuration));
        globalScopeSubscription.dispose();
      });
    });
  }
}